import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import plan1 from "../../../Assets/Icons/plan1.svg";
import plan2 from "../../../Assets/Icons/plan2.svg";
import plan3 from "../../../Assets/Icons/plan3.svg";
import "./style.css";
import { checkoutAPI, getAllPackages } from "../../../API/payments";
import { ClipLoader } from "react-spinners";

const Subscription = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const noBg = location.state?.noBg;
  const [packages, setPackages] = useState([]);

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str?.charAt(0).toUpperCase() + str.slice(1);
  };

  const fetchAllPackages = async () => {
    try {
      setLoading(true);
      const response = await getAllPackages();
      if (Math.floor(response?.status / 100) === 2) {
        const data = response?.data || [];
        setPackages(data);
      } else {
        message.error("Unexpected response from server.");
      }
    } catch (error) {
      message.error("Failed to fetch dashboard data Email Volume.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllPackages();
  }, []);

  const handleClick = async (package_name) => {
    try {
      setLoading(true);

      const baseUrl = window.location.origin;

      const payload = {
        package_name: package_name,
        success_url: `${baseUrl}/login?success=true`,
        cancel_url: `${baseUrl}/login?sucess=false`,
      };

      const response = await checkoutAPI(payload);

      if (Math.floor(response?.status / 100) === 2) {
        const checkoutUrl = response?.data?.checkout_url;

        if (checkoutUrl) {
          window.location.href = checkoutUrl;
        } else {
          message.success("Error getting the checkout URL");
        }
      } else {
        message.error(response?.data?.message || "Checkout failed");
      }
    } catch (error) {
      message.error("Something went wrong while initiating checkout");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="loader-container"
        >
          <ClipLoader size={50} color={"#123abc"} loading={loading} />
        </div>
      ) : (
        <div className={`plan ${noBg ? "no-bg" : ""}`}>
          <div className="back-btn">
            <Button icon={<ArrowLeftOutlined />} onClick={handleBack}>
              Back
            </Button>
          </div>
          <div className="feature">Features</div>

          <div className="heading">Simple Pricing,</div>
          <div className="sub-heading">Powerful Features</div>
          <div className="sub-content">
            Simple, transparent pricing that grows with you.
          </div>
          <div className="subs-div">
            <div className="div1">
              <div className="plan-logo">
                <img src={plan1} alt="plan1" />
              </div>
              <div className="title">
                {capitalizeFirstLetter(packages[0]?.package_name)}
              </div>
              <div className="pricing">
                {packages[0]?.amount}
                <span>{packages[0]?.currency}</span>
              </div>
              <div className="pricing-info"></div>
              <div className="feature-list">
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>Up to 25,000 emails / month</span>
                </div>
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>REST API & SMTP access</span>
                </div>
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>Basic analytics (sent, delivered, bounced)</span>
                </div>
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>Email support</span>
                </div>
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>1 API key</span>
                </div>
                <div className="feature-item">
                  Best for MVPs, testing, and low-volume apps
                </div>
                <div className="submit-btn">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-button"
                    loading={loading}
                    onClick={() => {
                      handleClick(packages[0]?.package_name);
                    }}
                  >
                    Get started
                  </Button>
                </div>
              </div>
            </div>
            <div className="div2">
              <div className="plan-logo">
                <img src={plan2} alt="plan2" />
              </div>
              <div className="title">
                {capitalizeFirstLetter(packages[1]?.package_name)}
              </div>
              <div className="pricing">
                {packages[1]?.amount}
                <span>{packages[1]?.currency}</span>
              </div>
              <div className="pricing-info"></div>
              <div className="feature-list">
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>Up to 150,000 emails / month</span>
                </div>
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>Detailed analytics and reporting</span>
                </div>
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>REST API, SMTP & Webhooks</span>
                </div>
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>Advanced analytics (opens, clicks, bounces)</span>
                </div>
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>Multiple API keys</span>
                </div>
                <div className="feature-item">
                  <span className="check">✔</span>
                  <span>Priority email support</span>
                </div>
                <div className="feature-item">
                  Best for SaaS products & growing platforms
                </div>
                <div className="submit-btn">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-button"
                    loading={loading}
                    onClick={() => {
                      handleClick(packages[1]?.package_name);
                    }}
                  >
                    Get started
                  </Button>
                </div>
              </div>
            </div>
            {/* <div className="div3">
          <div className="plan-logo">
            <img src={plan3} alt="plan3" />
          </div>
          <div className="title">Enterprise plan</div>
          <div className="pricing">Custom </div>
          <div className="pricing">(Contact Sales)</div>

          <div className="feature-list">
            <div className="feature-item">
              <span className="check">✔</span>
              <span>1M+ emails / month</span>
            </div>
            <div className="feature-item">
              <span className="check">✔</span>
              <span>Dedicated IP(s)</span>
            </div>
            <div className="feature-item">
              <span className="check">✔</span>
              <span>Dedicated email server (optional)</span>
            </div>
            <div className="feature-item">
              <span className="check">✔</span>
              <span>Real-time logs & monitoring</span>
            </div>
            <div className="feature-item">
              <span className="check">✔</span>
              <span>SLA & uptime guarantees</span>
            </div>
            <div className="feature-item">
              <span className="check">✔</span>
              <span>Account manager</span>
            </div>
            <div className="feature-item">
              <span className="check">✔</span>
              <span>WhatsApp / phone support</span>
            </div>
            <div className="feature-item">
              <span className="check">✔</span>
              <span>Custom integrations</span>
            </div>
            <div className="feature-item">
              Best for fintech, healthcare, large platforms
            </div>
            <div className="submit-btn">
              <Button
                type="primary"
                htmlType="submit"
                className="submit-button"
                loading={loading}
                onClick={handleClick}
              >
                Get started
              </Button>
            </div>
          </div>
        </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default Subscription;
